import { type ClientShop } from "@userFrontend/features/clientReview/components/ClientReviewInputs/type";
import { TextButton } from "@root/shared/components/TextButton";
import { type FC } from "react";
import { SearchResultContents } from "@userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/SearchResultContents";
import { NoShopBox } from "@userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/NoShopBox";
import * as styles from "./styles.css";

type Props = {
  clientName: string;
  clientShops: ClientShop[];
  showAllShops: boolean;
  onClickShowTextButton: () => void;
  onClickSelect: (shop: ClientShop) => void;
  onClickNoShopPost: () => void;
};

const MAX_SHOWN_SHOP_NAMES = 3;

export const SearchResultBox: FC<Props> = ({
  clientName,
  clientShops,
  showAllShops,
  onClickShowTextButton,
  onClickSelect,
  onClickNoShopPost,
}) => {
  const visibleShops = showAllShops ? clientShops : clientShops.slice(0, MAX_SHOWN_SHOP_NAMES);
  const hasMoreShops = clientShops.length > MAX_SHOWN_SHOP_NAMES;

  return (
    <>
      <div className={styles.clientName}>{clientName}</div>
      <div className={styles.searchResultListWrapper}>
        <div className={styles.searchResultListInner}>
          {visibleShops.map((clientShop) => (
            <div key={clientShop.shopId} className={styles.searchResultContentsWrapper}>
              <SearchResultContents
                shopName={clientShop.shopName || ""}
                shopAddress={clientShop.shopAddress}
                onClick={() => onClickSelect(clientShop)}
              />
            </div>
          ))}
        </div>
        <div className={styles.shopActionsWrapper}>
          {!showAllShops && hasMoreShops && (
            <TextButton isBold size="large" onClick={onClickShowTextButton} leftIconName="add-more">
              他の店舗を見る
            </TextButton>
          )}
          <div className={styles.NoShopBoxWrapper}>
            <NoShopBox onClick={onClickNoShopPost} />
          </div>
        </div>
      </div>
    </>
  );
};
